import { render, staticRenderFns } from "./serviceCode.vue?vue&type=template&id=cc190dd4&scoped=true"
import script from "./serviceCode.vue?vue&type=script&lang=js"
export * from "./serviceCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc190dd4",
  null
  
)

export default component.exports